// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cardsContainer[data-v-22153d4f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 25px 15px;\n  overflow-x: scroll;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}", ""]);
// Exports
module.exports = exports;
